/**
 * SimpleCache is a class that caches the results of a function that takes one string argument and returns a promise.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "SimpleCache", {
    enumerable: true,
    get: function() {
        return SimpleCache;
    }
});
class SimpleCache {
    data = {};
    accessor;
    constructor(accessor){
        this.accessor = accessor;
    }
    get(key) {
        if (this.data[key] === undefined) {
            this.data[key] = this.accessor(key);
        }
        return this.data[key];
    }
    async awaitAll() {
        await Promise.all(Object.values(this.data).map((promise)=>Promise.resolve(promise)));
    }
}
